import React, { Component } from 'react';

import styles from './styles.module.scss';

import WithUser from 'shared/HOCs/WithUser';
import Dropdown from 'shared/components/Navigation/NavLinks/Dropdown';
import { NavItem } from 'shared/components/Navigation/NavLinks/NavItem';
import { NAV_ITEMS } from 'shared/components/Navigation/NavLinks/constants';

class Tenders extends Component {
  render() {
    const { closeAction, closeNavigation, visible } = this.props;
    return (
      <Dropdown visible={visible}>
        <Dropdown.Header onClick={closeAction}>Procurement</Dropdown.Header>

        {NAV_ITEMS.TENDERS[this.props.user ? 'logged' : 'unlogged'].map(
          item => (
            <>
              {!(item.url || item.externalUrl) && (
                <span className={styles.category}>{item.title}</span>
              )}

              {(item.url || item.externalUrl) && (
                <NavItem
                  {...item}
                  key={item.title}
                  closeAction={closeAction}
                  closeNavigation={closeNavigation}
                />
              )}
            </>
          )
        )}
      </Dropdown>
    );
  }
}

export default WithUser(Tenders);
